var map = {
	"./1.mp3": 271,
	"./10.mp3": 272,
	"./11.mp3": 273,
	"./12.mp3": 274,
	"./2.mp3": 275,
	"./3.mp3": 276,
	"./4.mp3": 277,
	"./5.mp3": 278,
	"./6.mp3": 279,
	"./7.mp3": 280,
	"./8.mp3": 281,
	"./9.mp3": 282,
	"./_fieldclick.mp3": 283,
	"./bck1.mp3": 137,
	"./bck2.mp3": 138,
	"./bg.mp3": 284,
	"./bg.wav": 285,
	"./calculate.mp3": 124,
	"./calculate.wav": 286,
	"./fieldclick.mp3": 125,
	"./fieldclick.wav": 287,
	"./loading.mp3": 49,
	"./lucky.mp3": 288,
	"./lucky.wav": 289,
	"./start.mp3": 126,
	"./start.wav": 290,
	"./summarize.mp3": 127,
	"./top7.mp3": 161,
	"./top7.wav": 291,
	"./unlucky.mp3": 292,
	"./unlucky.wav": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;